// extracted by mini-css-extract-plugin
module.exports = {"product_list":"styles_product_list__18G4x","page_header":"styles_page_header__3odAl","calculator_layout":"styles_calculator_layout__2gbzS"};